// extracted by mini-css-extract-plugin
export default {"overlay":"loader_overlay__oe+wh","loader":"loader_loader__Eox5n","spin":"loader_spin__Lmk7+"};